import { ClerkProvider } from '@clerk/clerk-react';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import Layout from './components/Layout';
import { Toaster } from './components/ui/toaster';
import './index.css';
import CharacterDocumentChat from './pages/CharacterDocumentChat';
import CharacterChats from './pages/CharacterChats';
import Dashboard from './pages/Dashboard';
import Documents from './pages/Documents';
import EditDocument from './pages/EditDocument';
import Home from './pages/Home';
import Settings from './pages/Settings';
import SignInPage from './pages/SignIn';
import SubscriptionPage from './pages/SubscriptionPage';
import AIChat from './pages/AIChat';
import AIChats from './pages/AIChats';

if (import.meta.env.MODE !== 'development') {
  Sentry.init({
    dsn: 'https://be656c94d74a55cca8692ed0ae0b563c@o4508713743155200.ingest.de.sentry.io/4508713753706576',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      // Sentry.feedbackIntegration({
      //   colorScheme: 'system',
      //   triggerLabel: 'Feedback',
      //   formTitle: 'Feedback or Issue',
      //   submitButtonLabel: 'Send Feedback',
      // }),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/^https:\/\/app\.creativeaiwriter\.com\/api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

// DEV: pk_test_c2FjcmVkLWR1Y2tsaW5nLTcwLmNsZXJrLmFjY291bnRzLmRldiQ
// PROD: pk_live_Y2xlcmsuY3JlYXRpdmVhaXdyaXRlci5jb20k

const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const __VERSION__ = import.meta.env.VITE_GIT_SHA;

window.release_version = __VERSION__;
console.log(`App version: ${window.release_version}`);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <ClerkProvider publishableKey={clerkPubKey}>
    <Router>
      <ErrorBoundary>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/signin" element={<SignInPage />} />
            <Route path="/" element={<Home />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/edit-doc" element={<EditDocument />} />
            <Route path="/character-doc-chat" element={<CharacterDocumentChat />} />
            <Route path="/character-doc-chats" element={<CharacterChats />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/subscription" element={<SubscriptionPage />} />
            <Route path="/ai-chat" element={<AIChat />} />
            <Route path="/ai-chats" element={<AIChats />} />
          </Route>
        </Routes>
      </ErrorBoundary>
    </Router>
    <Toaster />
  </ClerkProvider>
);
